import { CaseReducer, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Coverage } from "src/classes/plan/Coverage";
import { Plan } from "src/classes/plan/Plan";
import { Person  } from "src/classes/Person";
import { Vehicle } from "src/classes/vehicle/Vehicle";
import { IPlanManagementStateReducer } from "src/store/states/libs-state/IPlanManagementStateReducer";

/**
 *
 */
export namespace PlanManagementSlice {
  /**
   * 
   */
  const initialState: IPlanManagementStateReducer = {
    plansList: [],
    coverages: [],
    coupon: '',
    isCustomizing: false,
    isUpdating: false,
    isLoading: false,
    user: undefined,
    vehicle: undefined,
    currentPlan: undefined,
    currentRecomendedPlan: undefined,
    isRenewal: false,
  };

  /**
   * 
   * @param state 
   * @param action 
   */
  const clear: CaseReducer<IPlanManagementStateReducer> = (state) => {
    state.plansList = [];
    state.coverages = [];
    state.coupon = '';
    state.isCustomizing = false;
    state.isUpdating = false;
    state.isLoading = false;
    state.user = undefined;
    state.vehicle = undefined;
    state.currentPlan = undefined;
    state.currentRecomendedPlan = undefined;
    state.isRenewal = false;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const plansList: CaseReducer<IPlanManagementStateReducer, PayloadAction<Plan[]>> = (state, action) => {
    state.plansList = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const coverages: CaseReducer<IPlanManagementStateReducer, PayloadAction<Coverage[]>> = (state, action) => {
    state.coverages = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const currentCoupon: CaseReducer<IPlanManagementStateReducer, PayloadAction<string>> = (state, action) => {
    state.coupon = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const isCustomizing: CaseReducer<IPlanManagementStateReducer, PayloadAction<boolean>> = (state, action) => {
    state.isCustomizing = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const isLoading: CaseReducer<IPlanManagementStateReducer, PayloadAction<boolean>> = (state, action) => {
    state.isLoading = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const isUpdating: CaseReducer<IPlanManagementStateReducer, PayloadAction<boolean>> = (state, action) => {
    state.isUpdating = action.payload;
  }

  /**
   * 
   * @param state 
   * @param action 
   */
  const setPlanConfiguration: CaseReducer<IPlanManagementStateReducer, PayloadAction<{ vehicle: Vehicle, user: Person, isRenewal?: boolean }>> = (state, action) => {
    state.vehicle = action.payload.vehicle;
    state.user = action.payload.user;
    state.isRenewal = action.payload.isRenewal;
  }
  /**
   * 
   * @param state 
   * @param action 
   */
  const setCurrentPlan: CaseReducer<IPlanManagementStateReducer, PayloadAction<Plan>> = (state, action) => {
    state.currentPlan = action.payload;
  }
  /**
   * 
   * @param state 
   * @param action 
   */
  const setCurrentRecomendedPlan: CaseReducer<IPlanManagementStateReducer, PayloadAction<Plan>> = (state, action) => {
    state.currentRecomendedPlan = action.payload;
  }

  const reducers = {
    clear,
    plansList,
    isCustomizing,
    isUpdating,
    isLoading,
    currentCoupon,
    coverages,
    setPlanConfiguration,
    setCurrentPlan,
    setCurrentRecomendedPlan
  };

  /**
   * 
   */
  const slice = createSlice({
    name: 'planManagement',
    initialState,
    reducers: reducers,
  });

  export const { reducer, actions } = slice;
}